export const OFFICIAL_NAME = "Ødegaard Consulting"
export const NAME = "Odecon"
export const CONTACT_MAIL = "kontakt@odecon.no"
export const CONTACT_PHONE = "+47 478 20 678"
export const ORG_NR = "824 437 432"
